export const SUPPORT_URL = "https://cequence.io/contact";
